import {CommentEditHistory} from '@github-ui/server-persisted-queries'
import type {CommentEditHistoryQuery} from '@github-ui/server-persisted-queries/types/CommentEditHistory'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type CommentNode = Extract<NonNullable<CommentEditHistoryQuery['node']>, {userContentEdits: unknown}>
type UserContentEditsConnection = NonNullable<CommentNode['userContentEdits']>

export type CommentEditHistoryData = {
  includesCreatedEdit: CommentNode['includesCreatedEdit']
  userContentEdits: UserContentEditsConnection
}

export function commentEditHistoryQueryKey(commentId: string) {
  return ['markdown-edit-history-viewer', 'edit-history', commentId] as const
}

export async function fetchCommentEditHistory(
  commentId: string,
  signal?: AbortSignal,
): Promise<CommentEditHistoryData> {
  const response = await verifiedFetchJSON(
    `/user_content_edits/edit_history/${encodeURIComponent(commentId)}?queryId=${CommentEditHistory}`,
    {
      signal,
    },
  )
  if (!response.ok) throw new Error(`Edit history fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: CommentEditHistoryQuery; errors?: unknown[]}
  if (!json.data) throw new Error('Edit history query returned no data')

  const node = json.data.node
  if (!node || !('userContentEdits' in node) || !node.userContentEdits) {
    throw new Error('Edit history query returned no edits')
  }

  return {includesCreatedEdit: node.includesCreatedEdit, userContentEdits: node.userContentEdits}
}
